/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A request to validate a rate (v2)
 * @export
 * @interface RateValidationRequestV2
 */
export interface RateValidationRequestV2 {
    /**
     * 
     * @type {number}
     * @memberof RateValidationRequestV2
     */
    gondolaRateId: number;
    /**
     * 
     * @type {boolean}
     * @memberof RateValidationRequestV2
     */
    includeRoomInfo?: boolean;
    /**
     * Optional response localization override for currency-sensitive validation flows such as Gondola Cash.
     * @type {string}
     * @memberof RateValidationRequestV2
     */
    localizedCurrency?: RateValidationRequestV2LocalizedCurrencyEnum;
}


/**
 * @export
 */
export const RateValidationRequestV2LocalizedCurrencyEnum = {
    Usd: 'USD'
} as const;
export type RateValidationRequestV2LocalizedCurrencyEnum = typeof RateValidationRequestV2LocalizedCurrencyEnum[keyof typeof RateValidationRequestV2LocalizedCurrencyEnum];


/**
 * Check if a given object implements the RateValidationRequestV2 interface.
 */
export function instanceOfRateValidationRequestV2(value: object): value is RateValidationRequestV2 {
    if (!('gondolaRateId' in value) || value['gondolaRateId'] === undefined) return false;
    return true;
}

export function RateValidationRequestV2FromJSON(json: any): RateValidationRequestV2 {
    return RateValidationRequestV2FromJSONTyped(json, false);
}

export function RateValidationRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): RateValidationRequestV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'gondolaRateId': json['gondola_rate_id'],
        'includeRoomInfo': json['include_room_info'] == null ? undefined : json['include_room_info'],
        'localizedCurrency': json['localized_currency'] == null ? undefined : json['localized_currency'],
    };
}

export function RateValidationRequestV2ToJSON(json: any): RateValidationRequestV2 {
    return RateValidationRequestV2ToJSONTyped(json, false);
}

export function RateValidationRequestV2ToJSONTyped(value?: RateValidationRequestV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gondola_rate_id': value['gondolaRateId'],
        'include_room_info': value['includeRoomInfo'],
        'localized_currency': value['localizedCurrency'],
    };
}

